// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AiComponentTypeSchema = z.enum(['AGENT','SUB_AGENT','TOOL','MCP_SERVER','MCP_TOOL','MCP_PROMPT','MCP_RESOURCE','MCP_PROTOCOL','RAG','MODEL','MEMORY','GUARDRAIL','INTEGRATION'] as const);

export type AiComponentTypeType = `${z.infer<typeof AiComponentTypeSchema>}`

export default AiComponentTypeSchema;
